import { useState } from 'react';
import DataTable from './DataTable';
import { theme } from '../theme';

const COLUMNS = [
  { key: 'id', label: 'ID' },
  { key: 'name', label: 'Nombre' },
  { key: 'description', label: 'Descripción' },
  { key: 'phone', label: 'Teléfono' },
  { key: 'timezone', label: 'Zona horaria' },
  { key: 'created_at', label: 'Creado' },
];

function Companies({ token, onSelectCompany }) {
  const [selecting, setSelecting] = useState(null);
  const [feedback, setFeedback] = useState('');

  const handleSelect = async (company) => {
    setSelecting(company.id);
    setFeedback('');
    try {
      const res = await fetch('/api/companies/select', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ company_id: company.id }),
      });
      const data = await res.json();
      if (res.ok) {
        localStorage.setItem('company_id', company.id);
        setFeedback(`Empresa "${company.name}" seleccionada correctamente.`);
        if (onSelectCompany) onSelectCompany(company.id);
      } else {
        setFeedback(data.message || 'Error al seleccionar empresa');
      }
    } catch {
      setFeedback('Error de conexión');
    } finally {
      setSelecting(null);
    }
  };

  return (
    <main style={{ padding: '2rem 1.5rem', maxWidth: '1100px', margin: '0 auto' }}>
      <div style={{
        backgroundColor: theme.colors.surface,
        borderRadius: '14px',
        border: `1px solid ${theme.colors.border}`,
        padding: '2rem',
        boxShadow: `0 4px 24px ${theme.colors.glowSubtle}`,
      }}>
        <div style={{ marginBottom: '1.5rem' }}>
          <h1 style={{ color: theme.colors.primary, fontSize: '1.5rem', marginBottom: '0.3rem' }}>
            Compañías
          </h1>
          <p style={{ color: theme.colors.textMuted, fontSize: '0.9rem' }}>
            Selecciona la empresa activa para filtrar la información en todos los módulos.
          </p>
        </div>

        {feedback && (
          <div style={{
            backgroundColor: feedback.includes('Error') ? 'rgba(248,113,113,0.1)' : 'rgba(74,222,128,0.1)',
            border: `1px solid ${feedback.includes('Error') ? theme.colors.error : theme.colors.success}`,
            borderRadius: '8px',
            padding: '0.75rem 1rem',
            marginBottom: '1.5rem',
            color: feedback.includes('Error') ? theme.colors.error : theme.colors.success,
            fontSize: '0.9rem',
          }}>
            {feedback}
          </div>
        )}

        <DataTable
          columns={COLUMNS}
          fetchUrl="/api/companies"
          token={token}
          renderActions={(row) => (
            <button
              onClick={() => handleSelect(row)}
              disabled={selecting === row.id}
              style={{
                padding: '6px 16px',
                backgroundColor: selecting === row.id ? theme.colors.border : theme.colors.primary,
                color: theme.colors.background,
                border: 'none',
                borderRadius: '6px',
                fontSize: '0.82rem',
                fontWeight: '700',
                cursor: selecting === row.id ? 'not-allowed' : 'pointer',
                whiteSpace: 'nowrap',
              }}
            >
              {selecting === row.id ? '...' : 'Seleccionar'}
            </button>
          )}
        />
      </div>
    </main>
  );
}

export default Companies;
